/** First mobile release that sends CivicChamps/{platform}/{version} in WebView user agent. */
export const RN_APP_USER_AGENT_MIN_VERSION = '1.30.0'

/** Matches CivicChamps/{ios|android}/{version}({build}) appended by the native WebView. */
export const RN_APP_USER_AGENT_PATTERN =
  /CivicChamps\/(ios|android)\/([\d.]+)\((\d+)\)/i

export type RNAppPlatform = 'ios' | 'android'

export type RNAppUserAgentInfo = {
  platform: RNAppPlatform
  version: string
  buildNumber: string
}

export const parseRNAppUserAgent = (
  userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : '',
): RNAppUserAgentInfo | null => {
  const match = userAgent.match(RN_APP_USER_AGENT_PATTERN)
  if (!match) {
    return null
  }

  return {
    platform: match[1].toLowerCase() as RNAppPlatform,
    version: match[2],
    buildNumber: match[3],
  }
}

/** Semver-style compare for numeric dot-separated version strings. */
export const compareAppVersions = (left: string, right: string): number => {
  const leftParts = left.split('.').map(part => parseInt(part, 10) || 0)
  const rightParts = right.split('.').map(part => parseInt(part, 10) || 0)
  const length = Math.max(leftParts.length, rightParts.length)

  for (let index = 0; index < length; index += 1) {
    const leftValue = leftParts[index] ?? 0
    const rightValue = rightParts[index] ?? 0

    if (leftValue > rightValue) {
      return 1
    }
    if (leftValue < rightValue) {
      return -1
    }
  }

  return 0
}

export const isRNAppAtLeast = (
  minVersion: string,
  userAgent?: string,
): boolean => {
  const parsed = parseRNAppUserAgent(userAgent)
  if (!parsed) {
    return false
  }

  return compareAppVersions(parsed.version, minVersion) >= 0
}
